var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIlustracaoLinksUteis = function SvgIlustracaoLinksUteis(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 352,
    height: 253,
    viewBox: "0 0 352 253",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4727_12673)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4727_12673)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.976 253.587C198.529 253.378 255.454 258.27 297.302 239.135C345.936 216.895 359.487 150.858 340.325 100.931C330.342 74.9212 311.842 52.6773 283.172 33.9802C235.326 2.77753 125.639 16.6845 73.8725 41.6096C41.52 57.187 -0.534668 97.5 15.5387 175.599C27.7469 234.918 90.77 253.92 156.976 253.587Z",
    fill: "url(#paint0_linear_4727_12673)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.6499,
    y: 217.86,
    width: 51.49,
    height: 2.47,
    fill: "url(#paint1_radial_4727_12673)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3313 119.25C32.7257 118.137 32.9403 116.939 32.9403 115.691C32.9403 109.787 28.1346 105 22.2064 105C16.2783 105 11.4726 109.787 11.4726 115.691C11.4726 116.846 11.6564 117.958 11.9964 119C7.91916 122.037 5.28003 126.884 5.28003 132.345C5.28003 136.415 6.74566 140.144 9.17987 143.037C6.74566 145.93 5.28003 149.658 5.28003 153.728C5.28003 157.422 6.48746 160.835 8.53067 163.597C6.48746 166.359 5.28003 169.772 5.28003 173.466C5.28003 182.664 12.7658 190.12 22 190.12C31.2342 190.12 38.72 182.664 38.72 173.466C38.72 169.772 37.5126 166.359 35.4694 163.597C37.5126 160.835 38.72 157.422 38.72 153.728C38.72 149.658 37.2544 145.93 34.8202 143.037C37.2544 140.144 38.72 136.415 38.72 132.345C38.72 127.032 36.2217 122.299 32.3313 119.25Z",
    fill: "#A0DBEA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2851 129.7V203.61H21.7151V129.7H22.2851Z",
    fill: "#889197"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.69029 203.04H36.1198L40.2401 219H3.57007L7.69029 203.04Z",
    fill: "#FAC8C9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.703,
    y: 247.203,
    width: 69.5567,
    height: 3.33667,
    fill: "url(#paint2_radial_4727_12673)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.722 95C314.722 95 308.338 104.636 305.454 109.727C304.608 111.221 303.877 112.393 303.238 113.416C301.701 115.88 300.701 117.485 299.915 120.657C298.803 125.148 298.995 128.967 299.612 132.301C300.229 135.636 301.587 142.627 301.587 142.627C301.587 142.627 308.345 140.09 311.333 136.777C314.32 133.464 316.484 130.035 318.231 125.027C319.978 120.019 320.416 114.924 319.776 109.727C319.135 104.53 314.722 95 314.722 95ZM260.512 117.796C261.507 116.944 265.555 120.192 268.194 124.171C269.476 126.104 270.161 127.669 271.026 129.646C271.941 131.738 273.059 134.291 275.299 138.231C277.229 141.626 278.979 143.906 280.452 145.824C282.304 148.237 283.718 150.078 284.5 152.848C285.904 157.821 281.912 161.647 281.912 161.647C281.912 161.647 276.646 164.31 269.6 161.647C262.554 158.984 257.385 146.279 256.858 139.199C256.332 132.119 259.518 118.649 260.512 117.796ZM346.033 129.272C347.764 125.734 349.974 117.512 348.932 117.661C348.526 117.72 347.368 118.936 345.819 120.562C343.394 123.108 340.012 126.659 337.058 128.348C335.257 129.378 333.368 130.15 331.364 130.97C327.983 132.353 324.272 133.872 320.091 136.988C313.431 141.952 311.439 145.831 309.628 149.864C307.816 153.897 308.671 160.67 308.671 160.67C308.671 160.67 324.502 153.439 331.889 146.898C339.277 140.357 343.112 135.246 346.033 129.272Z",
    fill: "#A0DBEA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.045 99.3135C314.328 99.3328 314.542 99.5777 314.522 99.8605L314.01 99.8256C314.522 99.8605 314.522 99.8606 314.522 99.8608L314.522 99.8613L314.522 99.8692L314.52 99.8925L314.513 99.9824C314.507 100.061 314.498 100.178 314.484 100.329C314.457 100.633 314.415 101.077 314.352 101.645C314.226 102.779 314.018 104.407 313.688 106.383C313.03 110.334 311.888 115.684 309.949 121.277C308.168 126.416 306.906 129.4 305.794 132.029C305.7 132.251 305.607 132.472 305.514 132.69C304.338 135.479 303.3 138.033 301.919 142.662C301.29 144.773 300.733 146.502 300.238 148.041L300.238 148.041C298.541 153.31 297.565 156.342 296.851 164.801C296.39 170.271 296.389 180.5 296.505 189.386C296.547 192.568 296.603 195.573 296.658 198.119C297.007 195.609 297.479 192.62 298.107 189.369C299.89 180.149 302.937 168.775 308.004 160.31L308.031 160.264C313.043 151.891 315.469 147.838 323.757 141.2C327.898 137.884 330.415 136.375 332.532 135.188C332.784 135.047 333.029 134.91 333.269 134.777L333.27 134.777C335.044 133.79 336.592 132.93 338.782 131.172C341.246 129.193 343.195 126.606 344.533 124.498C345.2 123.447 345.712 122.521 346.056 121.858C346.228 121.528 346.358 121.263 346.444 121.082C346.487 120.992 346.52 120.922 346.541 120.876L346.565 120.824L346.571 120.811L346.572 120.808L346.572 120.808C346.687 120.549 346.991 120.432 347.25 120.547C347.509 120.662 347.625 120.966 347.51 121.225L347.041 121.016C347.51 121.225 347.51 121.225 347.51 121.225L347.51 121.225L347.509 121.227L347.507 121.231L347.5 121.247L347.474 121.305C347.45 121.356 347.416 121.43 347.37 121.525C347.279 121.715 347.144 121.99 346.967 122.332C346.612 123.015 346.086 123.967 345.4 125.048C344.031 127.204 342.011 129.895 339.424 131.972C337.165 133.787 335.547 134.686 333.767 135.675C333.526 135.808 333.283 135.944 333.035 136.083C330.96 137.247 328.49 138.725 324.399 142.001C316.255 148.524 313.904 152.452 308.913 160.79L308.885 160.838C303.913 169.145 300.892 180.374 299.115 189.564C298.229 194.151 297.654 198.217 297.302 201.136C297.126 202.595 297.005 203.767 296.928 204.573C296.922 204.644 296.915 204.711 296.909 204.776C296.924 204.878 296.937 204.973 296.949 205.059C296.978 205.274 296.999 205.439 297.013 205.55L297.023 205.634L297.028 205.677L297.032 205.71L297.033 205.719L297.033 205.721L297.033 205.722C297.033 205.722 297.033 205.722 296.852 205.742L297.033 205.722C297.065 206.004 296.862 206.258 296.581 206.289C296.53 206.295 296.479 206.293 296.431 206.284C296.417 206.287 296.403 206.289 296.389 206.29C296.378 206.291 296.367 206.292 296.356 206.292C296.345 206.293 296.335 206.293 296.324 206.292C296.306 206.293 296.288 206.293 296.27 206.291C295.987 206.27 295.775 206.024 295.796 205.742L295.825 205.744L295.825 205.744C295.796 205.741 295.796 205.741 295.796 205.741L295.797 205.72L295.802 205.657C295.806 205.613 295.81 205.551 295.817 205.474L295.816 205.455C295.81 205.232 295.8 204.904 295.788 204.482L295.779 204.149C295.742 203.907 295.7 203.64 295.653 203.35C295.392 201.746 294.97 199.428 294.327 196.581C293.041 190.886 290.871 183.077 287.339 174.623C283.81 166.176 280.549 160.967 277.49 156.48C276.944 155.68 276.404 154.9 275.868 154.128L275.868 154.128C273.403 150.576 271.048 147.181 268.799 142.584C266.065 136.997 264.504 132.259 263.626 128.912C263.187 127.238 262.918 125.912 262.759 125.002C262.68 124.547 262.628 124.195 262.596 123.956C262.579 123.837 262.568 123.745 262.561 123.683C262.557 123.652 262.554 123.628 262.553 123.612L262.551 123.593L262.55 123.587L262.55 123.585C262.55 123.585 262.55 123.585 263.061 123.534L262.55 123.585C262.522 123.303 262.728 123.051 263.01 123.023C263.292 122.995 263.544 123.201 263.572 123.483L263.572 123.487L263.573 123.501C263.575 123.515 263.577 123.536 263.581 123.564C263.587 123.62 263.598 123.705 263.613 123.818C263.644 124.045 263.694 124.383 263.771 124.825C263.925 125.709 264.187 127.007 264.619 128.651C265.482 131.94 267.02 136.614 269.721 142.133C271.933 146.654 274.239 149.978 276.7 153.525L276.7 153.525L276.7 153.526C277.238 154.302 277.784 155.089 278.339 155.902C281.424 160.428 284.723 165.699 288.286 174.227C291.847 182.748 294.033 190.617 295.329 196.355C295.432 196.813 295.53 197.257 295.622 197.687C295.57 195.238 295.518 192.397 295.478 189.399C295.362 180.524 295.362 170.243 295.828 164.715C296.552 156.134 297.562 153 299.268 147.701C299.762 146.166 300.314 144.451 300.935 142.369C302.33 137.692 303.383 135.101 304.569 132.291C304.659 132.078 304.75 131.862 304.842 131.645L304.848 131.629C305.958 129.006 307.209 126.048 308.979 120.941C310.893 115.418 312.024 110.126 312.676 106.214C313.001 104.259 313.207 102.65 313.332 101.531C313.394 100.972 313.435 100.535 313.462 100.239C313.475 100.091 313.484 99.9781 313.49 99.9026L313.496 99.8177L313.498 99.7969L313.498 99.7908C313.517 99.508 313.762 99.2942 314.045 99.3135Z",
    fill: "#C5CFD6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M275.99 210.93C275.771 208.502 277.684 206.409 280.122 206.409H314.652C317.09 206.409 319.003 208.502 318.784 210.93L315.355 249H279.419L275.99 210.93Z",
    fill: "#8EC8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95 29.7084C95 26.6528 97.4771 24.1758 100.533 24.1758H260.467C263.523 24.1758 266 26.6528 266 29.7084V227.643C266 230.699 263.523 233.176 260.467 233.176H100.533C97.4771 233.176 95 230.699 95 227.643V29.7084Z",
    fill: "#C5D4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9961 29.5327C95.9961 26.4771 98.4732 24 101.529 24H260.227C263.283 24 265.76 26.4771 265.76 29.5327V40.6648H95.9961V29.5327Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109 54.1758H256V238.176H109V54.1758Z",
    stroke: "#84AAFF",
    strokeWidth: 1.38317,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.992,
    y: 63.2822,
    width: 122.327,
    height: 37.3455,
    rx: 1.38317,
    stroke: "#96B6FF",
    strokeWidth: 1.10653
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.666 70.1655H141.237",
    stroke: "#96B6FF",
    strokeWidth: 1.38317,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.402 70.1655H157.973",
    stroke: "#96B6FF",
    strokeWidth: 1.38317,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.546 70.1655H188.449",
    stroke: "#96B6FF",
    strokeWidth: 1.38317,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.666 77.0486H188.449",
    stroke: "#96B6FF",
    strokeWidth: 1.38317,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.666 83.9324H162.546",
    stroke: "#96B6FF",
    strokeWidth: 1.38317,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.992,
    y: 188.841,
    width: 122.327,
    height: 37.3455,
    rx: 1.38317,
    stroke: "#96B6FF",
    strokeWidth: 1.10653
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.666 195.724H141.237",
    stroke: "#96B6FF",
    strokeWidth: 1.38317,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.402 195.724H157.973",
    stroke: "#96B6FF",
    strokeWidth: 1.38317,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.546 195.724H188.449",
    stroke: "#96B6FF",
    strokeWidth: 1.38317,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.666 202.608H188.449",
    stroke: "#96B6FF",
    strokeWidth: 1.38317,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.666 209.491H162.547",
    stroke: "#96B6FF",
    strokeWidth: 1.38317,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.992,
    y: 158.997,
    width: 103.765,
    height: 8.85227,
    fill: "#96B6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.992,
    y: 144.06,
    width: 120.197,
    height: 8.299,
    fill: "#96B6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.992,
    y: 129.121,
    width: 120.197,
    height: 8.299,
    fill: "#96B6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.993,
    y: 114.183,
    width: 120.197,
    height: 8.299,
    fill: "#96B6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.993,
    y: 174.488,
    width: 63.9023,
    height: 4.42613,
    fill: "#96B6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.826 34.2985C109.969 34.2985 110.896 33.3717 110.896 32.2285C110.896 31.0852 109.969 30.1584 108.826 30.1584C107.683 30.1584 106.756 31.0852 106.756 32.2285C106.756 33.3717 107.683 34.2985 108.826 34.2985Z",
    fill: "#C5D4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.401 34.2985C116.544 34.2985 117.471 33.3717 117.471 32.2285C117.471 31.0852 116.544 30.1584 115.401 30.1584C114.258 30.1584 113.331 31.0852 113.331 32.2285C113.331 33.3717 114.258 34.2985 115.401 34.2985Z",
    fill: "#84AAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.977 34.2985C123.121 34.2985 124.047 33.3717 124.047 32.2285C124.047 31.0852 123.121 30.1584 121.977 30.1584C120.834 30.1584 119.907 31.0852 119.907 32.2285C119.907 33.3717 120.834 34.2985 121.977 34.2985Z",
    fill: "#002451"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.847,
    y: 30.1584,
    width: 103.612,
    height: 5.79645,
    fill: "#C5D4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.0446 122.809L88.5604 122.809C113.552 181.295 100.31 247.45 100.31 247.45L95.2745 247.45C95.2745 247.45 90.0173 197.098 81.8463 172.795C81.8463 204.025 52.7513 235.438 52.7513 235.438L48.4619 232.667C76.6238 175.197 50.5133 151.36 66.0446 122.809Z",
    fill: "#D09A6E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.158 231.4C49.158 231.4 49.8058 232.766 50.4906 233.42C51.172 234.071 52.8329 234.918 52.8329 234.918C54.5216 236.537 56.1245 239.274 57.0919 241.337C57.8872 243.033 59.1359 246.003 59.1359 246.003C59.9312 247.699 59.3784 248.652 58.9957 249.043L58.6506 249.396C58.3258 249.729 57.7915 249.738 57.4565 249.417L43.2641 235.83C42.6643 235.255 42.7522 234.779 43.2384 234.281L46.7697 231.442C47.4194 230.778 48.4881 230.759 49.158 231.4Z",
    fill: "#D3D4DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4311 234.123L58.9958 249.043L58.0539 250.008L42.4697 235.069L43.2232 234.297L43.4311 234.123Z",
    fill: "#AAAAB9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.3821 246.685C95.3821 246.685 96.8062 247.221 97.7573 247.219C98.7037 247.217 100.492 246.682 100.492 246.682C102.842 246.682 105.914 247.544 108.058 248.361C109.819 249.032 112.801 250.306 112.801 250.306C114.563 250.977 114.834 252.042 114.834 252.587L114.834 253.079C114.833 253.541 114.456 253.916 113.99 253.917L94.255 253.93C93.4205 253.93 93.1497 253.527 93.1497 252.834L93.695 248.361C93.6956 247.436 94.4506 246.686 95.3821 246.685Z",
    fill: "#D3D4DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1768 252.587H114.834V253.93H93.1497V252.856L93.1768 252.587Z",
    fill: "#AAAAB9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.56 194.485C106.967 211.957 102.661 239.069 102.661 239.069L92.8492 239.069L72.4062 147.706L73.5486 122.971L90.8934 122.417C100.61 140.202 105.876 165.138 106.56 194.485Z",
    fill: "#E76F00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9023 122.601L87.1636 122.601C87.1636 122.601 90.3683 158.49 86.2311 185.43C83.275 204.679 58.0873 231.499 58.0873 231.499L50.2542 226.695C50.2542 226.695 59.7885 206.5 61.4261 185.43C62.4565 172.172 59.2491 165.617 59.1881 152.352C59.1539 144.92 59.1881 133.735 65.9023 122.601Z",
    fill: "#FF8C54"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.4162 83.8916C72.4162 83.8916 63.6613 83.3779 60.2792 86.8278C51.3509 95.9351 35.1625 87.3102 31.7039 78.1344C28.7295 70.2433 30.4137 69.9499 30.0308 69.5092C28.9151 68.225 27.2423 70.6103 27.2423 70.6103C27.2423 70.6103 26.1373 65.8549 24.0821 67.1232C21.1082 68.9585 22.292 73.5258 22.595 74.6477C23.3385 77.4001 24.8257 77.2165 28.3578 84.9242C29.4589 87.3271 34.1207 94.834 45.4605 99.6054C52.1275 102.411 63.3072 104.629 63.3072 104.629L66.2814 122.797L89.8908 122.797L92.4936 103.342C107.366 103.892 122.737 98.7242 129.302 85.3573C132.276 79.3013 134.135 78.3837 134.693 76.3651C135.93 71.886 134.321 68.801 132.648 68.6574C131.352 68.5461 130.603 71.4102 130.045 72.3277C129.488 71.9607 128.744 70.1255 127.443 71.0431C126.671 71.587 128.744 71.4101 125.212 80.2189C121.533 89.3946 107.044 97.5532 91.5641 86.8278C88.15 84.4623 83.1984 83.8916 83.1984 83.8916L72.4162 83.8916Z",
    fill: "#D09A6E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5384 122.358C90.5384 122.358 78.4549 123.46 65.9996 122.358C60.9759 107.894 65.5585 87.634 72.692 83.4531C72.692 83.4531 75.662 85.8803 78.6408 85.8388C81.5238 85.7987 84.0319 84.0037 84.0319 84.0037C93.2576 90.0197 93.4435 112.776 90.5384 122.358Z",
    fill: "#FFC8B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.9047 170.44H75.5123C75.9616 161.165 77.5572 87.4914 77.5572 87.4914L72.7238 83.454C66.6057 83.1688 62.0245 84.825 57.9655 86.2924C50.0156 89.1664 44.0688 91.3163 32.5006 76.7378L25.6223 80.9586C29.4489 96.9803 44.1396 103.537 52.3441 107.199C55.6987 108.697 57.9689 109.71 57.9689 110.688C57.9689 125.736 54.2694 153.229 50.9047 170.44ZM95.5202 86.5431C104.451 89.7284 113.376 92.9115 124.707 78.6401L130.842 82.6775C126.507 100.054 111.131 104.034 102.085 106.376C98.3295 107.349 95.6649 108.038 95.3349 109.287C94.2376 113.439 107.301 171.357 107.301 171.357H86.4806L82.019 87.674L83.878 83.8202C87.8855 83.8202 91.7034 85.1819 95.5202 86.5431Z",
    fill: "#F0F0F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.4501 68.6145C88.4204 70.0093 90.8374 70.9798 90.8374 72.1625C90.8374 73.3451 90.0568 73.7918 89.1962 74.2321C89.1961 76.2811 88.9198 77.9696 87.1073 79.4062C85.6153 80.5889 83.7214 80.4411 83.2931 81.3281C82.8648 82.215 83.9469 83.4716 83.9469 83.4716C83.9469 83.4716 81.773 86.2435 78.6025 86.2435C75.4319 86.2435 72.4479 83.4716 72.4479 83.4716C73.8216 80.8846 73.8216 75.4932 73.8216 75.4932C73.3982 74.9794 73.0698 74.5731 73.0698 74.5731C73.0698 74.5731 71.9184 73.1096 71.5043 71.6418C71.0903 70.174 71.3733 68.3965 71.5808 67.4651C71.8297 66.3473 72.3467 65.2252 73.0698 64.3028C73.8023 63.3684 74.7143 62.4961 76.534 61.722C80.1502 60.1838 82.9824 61.2729 83.9469 61.722C84.9114 62.1711 85.8446 62.835 86.7396 63.8205C87.6347 64.806 88.4977 66.3831 88.4501 68.6145Z",
    fill: "#D09A6E"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.49203,
    height: 2.95664,
    rx: 0.746014,
    transform: "matrix(-1 0 0 1 86.8086 68.0232)",
    fill: "#24252E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.3645 74.7045C76.3645 74.7045 73.7984 72.709 75.9169 70.2407C76.4499 69.6196 78.6026 69.3808 79.5023 70.664C82.3832 67.2289 85.3167 63.4896 85.3167 62.5058C83.9367 61.3516 82.1155 60.7282 79.5023 60.9843C76.8891 61.2405 74.615 62.0465 73.0821 64.0317C72.232 64.8236 72.0377 64.9187 70.9932 64.9187C69.9488 64.9187 67.2633 62.9969 63.384 65.2144C60.3999 67.284 61.1459 70.832 61.1459 70.832C59.057 70.832 56.3714 73.493 56.2222 76.7453C56.2222 80.5889 58.9078 81.0324 58.9078 81.0324C58.9078 81.0324 58.311 85.4578 62.1903 86.9457C66.8156 88.7196 68.606 86.0587 68.606 86.0587C68.606 86.0587 71.2916 88.7627 74.8725 87.2413C77.1895 86.2569 78.3212 84.1215 78.3042 81.6237C78.2825 78.4388 75.4693 77.3366 75.4693 77.3366C75.4693 77.3366 76.3645 76.4496 76.3645 74.7045Z",
    fill: "#642B00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.6976 47.5088H84.0276H86.7027C86.7081 47.3069 86.7107 47.1001 86.7107 46.8884C86.7107 46.229 86.7642 46.1224 88.548 43.0686C90.0254 40.5389 90.7346 38.6713 90.7346 36.4538C90.7346 31.457 86.4564 28 81.3633 28C76.2715 28 72 31.4531 72 36.4538C72 38.6726 72.7039 40.522 74.1826 43.0452C75.9276 46.0248 76.0146 46.1965 76.0146 46.8884C76.0146 47.1001 76.0172 47.3069 76.0227 47.5088H78.6976ZM84.8011 44.2508C84.686 44.4784 84.583 44.6956 84.4933 44.9076H78.244C78.1517 44.6878 78.0459 44.4602 77.9268 44.2248C77.7422 43.8606 77.5321 43.4848 77.2444 42.9957C77.156 42.8462 76.6529 42.0047 76.5084 41.7576C75.2411 39.5947 74.6764 38.1121 74.6764 36.4538C74.6764 33.0073 77.6512 30.6012 81.3633 30.6012C85.0754 30.6012 88.0583 33.0099 88.0583 36.4538C88.0583 38.1134 87.4895 39.6142 86.2196 41.7849C86.0684 42.045 85.5505 42.9151 85.4836 43.0257C85.1945 43.5173 84.9844 43.8906 84.8011 44.2508Z",
    fill: "#FCCE74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3633 51.3975C79.3828 51.3975 78.7645 50.5847 78.6976 47.5088H76.0227C76.1416 51.9211 77.5833 53.9988 81.3633 54C85.1533 54 86.5853 51.9463 86.7027 47.5088H84.0276C83.9621 50.6094 83.3559 51.3975 81.3633 51.3975Z",
    fill: "#498FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0276 47.5088H78.6976C78.7645 50.5847 79.3828 51.3975 81.3633 51.3975C83.3559 51.3975 83.9621 50.6094 84.0276 47.5088Z",
    fill: "#498FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.4933 44.9076C84.583 44.6956 84.686 44.4784 84.8011 44.2508C84.9844 43.8906 85.1945 43.5173 85.4836 43.0257C85.5505 42.9151 86.0684 42.045 86.2196 41.7849C87.4895 39.6142 88.0583 38.1134 88.0583 36.4538C88.0583 33.0099 85.0754 30.6012 81.3633 30.6012C77.6512 30.6012 74.6764 33.0073 74.6764 36.4538C74.6764 38.1121 75.2411 39.5947 76.5084 41.7576C76.6529 42.0047 77.156 42.8462 77.2444 42.9957C77.5321 43.4848 77.7422 43.8606 77.9268 44.2248C78.0459 44.4602 78.1517 44.6878 78.244 44.9076H84.4933ZM81.3646 34.5016C82.8126 34.5016 84.0437 35.6409 84.0437 37.1041C84.0437 37.1041 84.0517 38.4042 85.3852 38.4047C86.7187 38.4042 86.7187 37.1041 86.7187 37.1041C86.7187 35.7244 86.1548 34.4011 85.1509 33.4255C84.1471 32.4499 82.7856 31.9018 81.366 31.9018C81.366 31.9018 80.0278 31.9031 80.0278 33.2023C80.0278 34.5016 81.3646 34.5016 81.3646 34.5016Z",
    fill: "#FCCE74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0437 37.1041C84.0437 35.6409 82.8126 34.5016 81.3646 34.5016C81.3646 34.5016 80.0278 34.5016 80.0278 33.2023C80.0278 31.9031 81.366 31.9018 81.366 31.9018C82.7856 31.9018 84.1471 32.4499 85.1509 33.4255C86.1548 34.4011 86.7187 35.7244 86.7187 37.1041C86.7187 37.1041 86.7187 38.4042 85.3852 38.4047C84.0517 38.4042 84.0437 37.1041 84.0437 37.1041Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.245,
    cy: 61.1532,
    r: 61.1415,
    fill: "#498FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.649 30.4531C263.389 23.7132 270.129 23.7132 276.872 30.4531C283.616 37.1965 283.616 43.94 276.872 50.6798L258.852 68.7112C252.112 75.4547 245.372 75.4547 238.628 68.7112C238.628 68.7112 236.101 66.1833 238.628 63.6554C240.313 61.9714 242 61.9714 243.684 63.6554C247.056 67.0271 250.428 67.0271 253.799 63.6554L271.82 45.6241C275.188 42.2523 275.188 38.8806 271.82 35.5125C268.445 32.1407 265.077 32.1407 261.701 35.5125L253.074 44.1438C251.386 45.8279 249.702 45.8279 248.014 44.1438C246.33 42.4561 246.33 40.7721 248.014 39.088L256.649 30.4531ZM235.772 91.7734C229.028 98.5168 222.288 98.5168 215.545 91.7734C208.805 85.0335 208.805 78.2936 215.545 71.5502L233.569 53.5403C240.313 46.7968 247.052 46.7968 253.796 53.5403C253.796 53.5403 256.324 56.0682 253.796 58.5961C252.108 60.2837 250.424 60.2837 248.74 58.5961C245.368 55.2243 241.997 55.2243 238.625 58.5961L220.604 76.606C217.233 79.9777 217.233 83.3494 220.604 86.7176C223.972 90.0893 227.344 90.0893 230.716 86.7176L239.347 78.0863C241.031 76.4022 242.719 76.4022 244.403 78.0863C246.091 79.7739 246.091 81.458 244.403 83.142L235.772 91.7769V91.7734Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4727_12673",
    x1: 181.05,
    y1: 237.245,
    x2: 181.05,
    y2: -4.03814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5D4FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4727_12673",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.0951 219.095) rotate(90) scale(1.235 25.745)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_4727_12673",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(297.482 248.872) rotate(90) scale(1.66834 34.7783)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4727_12673"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 352,
    height: 253,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4727_12673"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 352,
    height: 254,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIlustracaoLinksUteis, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ilustracao-links-uteis.8b67e563.svg";
export { ForwardRef as ReactComponent };